import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-glens-single-select',
  templateUrl: './glens-single-select.component.html',
  styleUrls: ['./glens-single-select.component.scss']
})
export class GlensSingleSelectComponent implements OnInit, OnChanges {
  @Input() model;
  @Input() settings;
  @Input() options;
  @Input() form;
  @Output() actions: EventEmitter<any>;

  public dropdownSettings;


  constructor() {
    this.actions = new EventEmitter();
  }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    try {
      this.mapModel();
    } catch (error) {
      console.log(error);
    }
  }
  mapModel() {
    try {
      let index;
      if (this.settings.options.length > 0) {
        if (typeof (this.settings.options[0]) === 'object') {
          index = this.settings.options.findIndex(opt => opt[this.settings.bindValue || 'key'] === this.model);
          if (index === -1) {
            this.model = this.settings.options[0][this.settings.bindValue || 'key'];
          }
        } else {
          index = this.settings.options.findIndex(opt => opt === this.model);
          if (index === -1) {
            this.model = this.settings.options[0];
          }
        }
      } else {
        // this.model = undefined;
      }
      setTimeout(() => {
        this.changeDDValue();
      }, 200);
    } catch (error) {
      console.log(error);
    }
  }
  changeDDValue(event?) {
    this.form[this.settings.key] = this.model;
    this.actions.emit(this.model);
  }
}
